import { render, staticRenderFns } from "./editMobileMoneyAccountForm.vue?vue&type=template&id=0252662d"
import script from "./editMobileMoneyAccountForm.vue?vue&type=script&lang=js"
export * from "./editMobileMoneyAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports